import { render, staticRenderFns } from "./NoService.vue?vue&type=template&id=1818c1fa&scoped=true&"
import script from "./NoService.vue?vue&type=script&lang=js&"
export * from "./NoService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818c1fa",
  null
  
)

export default component.exports